import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from '../../iwProvider/configureStore';
import {
    getQueryParameter,
    getWindowLocation
} from '../../iwRouter/LocationHelper';
import { UploadSVG } from '../../svgComponents/uploadSVG';
import { OPEN_BANKING_MODAL } from '../modals/linkOpenBankingModal/LinkOpenBankingModal.actions';
import { SHOW_UPLOAD_DOCUMENTS_MODAL } from '../modals/uploadDocumentsModal/UploadDocumentsModal.actions';
import MainContentPending from '../pageStructure/mainContentPending';
import { MainSectionWrapper } from '../pageStructure/mainSectionWrapper';
import { TitleSectionWrapper } from '../pageStructure/titleSectionWrapper/TitleSectionWrapper';
import LinkedAccounts from './linkedAccounts/LinkedAccounts';
import styles from './TradingData.module.css';
import messages from './TradingData.messages';
import { UploadedDocuments } from './uploadedDocuments/UploadedDocuments';
import { useStateKey } from '../../iwQueryClient/useStateKey';
import { trackPageView } from '../../tracking/pageView';

const mapStateToProps = ({ tradingData }: RootState) => tradingData;

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        uploadNewDocumentType: () =>
            dispatch({ type: SHOW_UPLOAD_DOCUMENTS_MODAL }),
        openLinkBankAccountModal: () => dispatch({ type: OPEN_BANKING_MODAL })
    };
};

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps> & {
        uploaded_documents: object;
    };

const TradingData = ({
    ready,
    uploaded_documents,
    uploadNewDocumentType,
    openLinkBankAccountModal
}: PropsFromRedux) => {
    const stateKey = useStateKey();
    useEffect(() => {
        const location = getWindowLocation();
        const linkOpenBankingModalQueryParam =
            getQueryParameter(location, 'modal') === 'LinkOpenBankingModal';
        const truelayerRefererQueryParam =
            getQueryParameter(location, 'referer') === 'truelayer_callback';

        if (linkOpenBankingModalQueryParam && truelayerRefererQueryParam)
            openLinkBankAccountModal();
    });

    useEffect(() => {
        if (ready) {
            trackPageView(stateKey, 'Trading Data');
        }
    }, [stateKey, ready]);

    if (!ready)
        return <MainContentPending data-testid="trading-data-loading" />;

    return (
        <div data-testid="tradingData" className={styles.TradingData}>
            <TitleSectionWrapper>
                <div className={styles.title}>
                    <FormattedMessage {...messages.title} />
                </div>
            </TitleSectionWrapper>
            <MainSectionWrapper>
                <LinkedAccounts />
                <UploadedDocuments uploaded_documents={uploaded_documents} />
                <button
                    className={styles.uploadNewDocumentType}
                    onClick={uploadNewDocumentType}
                    title="upload document button"
                >
                    <UploadSVG className={styles.uploadIcon} />
                    <FormattedMessage {...messages.uploadNewDocumentType} />
                </button>
            </MainSectionWrapper>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, mapDispatchToProps)(TradingData);
